'use strict';

angular.module('planInitiativeModule', [
    'governanceProcessModule',
    'boxTemplateModule'
]);